export const TimeOfBirthItems = [
  { idx: 0, text: '모름' },
  { idx: 1, text: '子(자) 23:30 ~ 01:29' },
  { idx: 2, text: '丑(축) 01:30 ~ 03:29' },
  { idx: 3, text: '寅(인) 03:30 ~ 05:29' },
  { idx: 4, text: '卯(묘) 05:30 ~ 07:29' },
  { idx: 5, text: '辰(진) 07:30 ~ 09:29' },
  { idx: 6, text: '巳(사) 09:30 ~ 11:29' },
  { idx: 7, text: '午(오) 11:30 ~ 13:29' },
  { idx: 8, text: '未(미) 13:30 ~ 15:29' },
  { idx: 9, text: '申(신) 15:30 ~ 17:29' },
  { idx: 10, text: '酉(유) 17:30 ~ 19:29' },
  { idx: 11, text: '戌(술) 19:30 ~ 21:29' },
  { idx: 12, text: '亥(해) 21:30 ~ 23:29' },
]

export const BankList = [
  '기업은행',
  '국민은행',
  '신한은행',
  '우리은행',
  'KEB하나은행',
  '농협은행',
  '지역농축협',
  'SC제일은행',
  '한국시티은행',
  '우체국',
  '경남은행',
  '광주은행',
  '대구은행',
  '도이치',
  '부산은행',
  '산림조합',
  '산업은행',
  '저축은행',
  '새마을금고',
  '수협',
  '신협',
  '전북은행',
  '제주은행',
  'BOA',
  'HSBC',
  'JP모간',
  '중국공상은행',
  '비엔피파리바은행',
  '중국건설은행',
  '카카오뱅크',
  '케이뱅크',
  '교보증권',
  '대신증권',
  '미래에셋대우',
  'DB금융투자',
  '유안타증권',
  '메리츠증권',
  '부국증권',
  '삼성증권',
  '솔로몬투자증권',
  '신영증권',
  '신한금융투자',
  'NH투자증권',
  '유진투자증권',
  '이베스트증권',
  '키움증권',
  '하나금융투자',
  '하이투자',
  '한국투자',
  '한화증권',
  'KB증권',
  '현대차투자증권',
  '토스뱅크',
  '케이프투자증권',
  'SK증권',
  'KTB투자증권',
  '한국포스증권',
]
